import CheckList from "components/CheckList";
import type { CheckListProps } from "components/CheckList";
import type { ReactStoryblokComponent } from "types/storyblok";

const CheckListAdapter = ({
  blok: {
    heading,
    bgColor = "greyscale.200",
    containerFilling = "contain",
    listItems: storyblokListItems,
    fontSize = "lg",
  },
}: ReactStoryblokComponent<CheckListProps>) => {
  const listItems = storyblokListItems.map(({ _uid, text, iconType }) => ({
    _uid,
    text,
    iconType: !iconType ? "success" : iconType,
  }));

  return (
    <CheckList
      heading={heading}
      bgColor={bgColor}
      containerFilling={containerFilling}
      fontSize={fontSize}
      listItems={listItems}
    />
  );
};

export default CheckListAdapter;
